import { ComponentProps } from "react";
import classNames from "classnames";
import AlertCircleFilledIcon from "app/icons/navigation/AlertCircleFilledIcon";
import { ICON_SIZES } from "app/constants";
import Typography from "app/pages/.shared/Typography/Typography";
import styles from "./FieldHint.module.scss";

type FieldHintProps = {
	variant?: "help" | "error";
} & ComponentProps<"div">;

// Help/Error text below a field (Figma "_Hint" node). Whether to render a hint at all, and
// when an error becomes visible/announced, is a Layer 2 (form adapter) decision — see
// input-design-system-migration-plan.md section 4.5 (unresolved: announcement timing).
const FieldHint = ({ variant = "help", className, children, ...props }: FieldHintProps) => {
	return (
		<div
			className={classNames(
				styles["field-hint"],
				styles[`field-hint--${variant}`],
				className
			)}
			{...props}
		>
			{variant === "error" && (
				<AlertCircleFilledIcon
					size={ICON_SIZES.XS}
					aria-hidden="true"
					className={styles["field-hint__icon"]}
				/>
			)}
			{/* No variant: font-size/line-height/color are already fully driven by .field-hint's own
				classes above — this is just the tag swap, no visual change. */}
			<Typography component="span">{children}</Typography>
		</div>
	);
};

export { FieldHint };
